
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nfl/draft/[year]/draft-history/draft-by-year",
      function () {
        return require("private-next-pages/nfl/draft/[year]/draft-history/draft-by-year/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nfl/draft/[year]/draft-history/draft-by-year"])
      });
    }
  